import React, { Component } from "react";
import { Navigate } from "react-router-dom";

export default class RootPage extends Component {
  render() {
    const token = localStorage.getItem("token");

    if (token) {
      return <Navigate to="/chats" replace />;
    }

    return <Navigate to="/login" replace />;
  }
}
